export enum FontWeight {
    Light = '200',
    Default = '300',
    Medium = '500',
    SemiBold = '600',
    Bold = '700',
}
